/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Hero_DescInputs */

const en_b2b_hero_desc = /** @type {(inputs: B2b_Hero_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminate the friction of high-ticket sales. Deploy a white-labeled, AI-powered storefront on your custom domain in 60 seconds. Compliant B2B invoicing and VIP lead interception included.`)
};

const es_b2b_hero_desc = /** @type {(inputs: B2b_Hero_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina la fricción en ventas de alto valor. Despliega una tienda impulsada por IA en tu dominio en 60 segundos.`)
};

const fr_b2b_hero_desc = /** @type {(inputs: B2b_Hero_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éliminez les frictions des ventes à prix élevé. Déployez une vitrine en marque blanche propulsée par l'IA sur votre domaine personnalisé en 60 secondes. Facturation B2B conforme et interception de prospects VIP incluses.`)
};

const de_b2b_hero_desc = /** @type {(inputs: B2b_Hero_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminiere die Reibung bei High-Ticket-Verkäufen. Stelle eine whitelabeled, KI-gesteuerte Storefront in 60 Sekunden bereit.`)
};

const id_b2b_hero_desc = /** @type {(inputs: B2b_Hero_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilangkan gesekan penjualan harga tinggi. Luncurkan etalase bertenaga AI dengan white-label di domain kustom Anda dalam 60 detik. Termasuk penagihan B2B yang patuh dan intersepsi prospek VIP.`)
};

/** @type {(inputs: B2b_Hero_DescInputs) => LocalizedString} */
const ja_b2b_hero_desc = en_b2b_hero_desc;

/** @type {(inputs: B2b_Hero_DescInputs) => LocalizedString} */
const zh_b2b_hero_desc = en_b2b_hero_desc;

/** @type {(inputs: B2b_Hero_DescInputs) => LocalizedString} */
const ar_b2b_hero_desc = en_b2b_hero_desc;

/** @type {(inputs: B2b_Hero_DescInputs) => LocalizedString} */
const it_b2b_hero_desc = en_b2b_hero_desc;

/** @type {(inputs: B2b_Hero_DescInputs) => LocalizedString} */
const ru_b2b_hero_desc = en_b2b_hero_desc;

/** @type {(inputs: B2b_Hero_DescInputs) => LocalizedString} */
const pt_b2b_hero_desc = en_b2b_hero_desc;

/** @type {(inputs: B2b_Hero_DescInputs) => LocalizedString} */
const ko_b2b_hero_desc = en_b2b_hero_desc;

/**
* | output |
* | --- |
* | "Eliminate the friction of high-ticket sales. Deploy a white-labeled, AI-powered storefront on your custom domain in 60 seconds. Compliant B2B invoicing and V..." |
*
* @param {B2b_Hero_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_hero_desc = /** @type {((inputs?: B2b_Hero_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Hero_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_hero_desc(inputs)
	if (locale === "es") return es_b2b_hero_desc(inputs)
	if (locale === "fr") return fr_b2b_hero_desc(inputs)
	if (locale === "de") return de_b2b_hero_desc(inputs)
	if (locale === "ja") return ja_b2b_hero_desc(inputs)
	if (locale === "zh") return zh_b2b_hero_desc(inputs)
	if (locale === "ar") return ar_b2b_hero_desc(inputs)
	if (locale === "id") return id_b2b_hero_desc(inputs)
	if (locale === "it") return it_b2b_hero_desc(inputs)
	if (locale === "ru") return ru_b2b_hero_desc(inputs)
	if (locale === "pt") return pt_b2b_hero_desc(inputs)
	return ko_b2b_hero_desc(inputs)
});